import { createPortal } from "react-dom";
import { TgEmoji } from "@/components/TgEmoji";
import { popupActionsCol, popupBtnPrimary, popupBtnSecondary } from "@/lib/popupButtons";

/**
 * «Точно не подвоювати?» (owner 2026-10-25): подвоїти приз можна лише в моменті виграшу. Людина закриває попап
 * призу чи вікно подвоєння — питаємо ще раз; «Пропустити» — можливість зникає назавжди.
 */
export function WheelDoubleSkipPopup({
  prize,
  doubled,
  onDouble,
  onSkip,
  busy,
}: {
  prize: string;
  doubled: string;
  onDouble: () => void;
  onSkip: () => void;
  busy?: boolean;
}) {
  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4" onClick={onDouble}>
      <div
        className="fade-in relative w-full max-w-xs overflow-hidden rounded-3xl bg-surface p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div className="mb-2 flex justify-center">
            <TgEmoji char="⏳" size={48} />
          </div>
          <div className="mb-1.5 font-display text-[1.125rem] font-bold leading-tight text-ink [text-wrap:balance]">
            Точно не подвоювати?
          </div>
          <div className="text-[0.8125rem] leading-relaxed text-ink-dim [text-wrap:balance]">
            Перетворити <b className="whitespace-nowrap text-ink">{prize}</b> на <b className="whitespace-nowrap text-ink">{doubled}</b> можна тільки зараз{"\u00a0"}—
            потім цієї кнопки вже не буде.
          </div>
        </div>
        <div className={popupActionsCol + " mt-4"}>
          <button type="button" onClick={onDouble} className={popupBtnPrimary}>
            Подвоїти
          </button>
          <button type="button" onClick={onSkip} disabled={busy} className={popupBtnSecondary}>
            Пропустити
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
